import { getAppConfigSingleton } from "@expert/app-config";
import { getLogger } from "@expert/logging";
import type { Partner } from "@expert/shared-types";
import { HTTPError } from "ky";
import { getSharedApiClient } from "@/shared-utils";
import { env } from "../environment";
import type { ChannelShareData } from "./types";

const logger = getLogger({
    module: "getChannelShareData",
});

const channel = "Expert-Workspace";

/**
 * @see https://ivr3.dev.rtt.contactcenter.npr.aws.asurion.net/docs#post-/api/v1/csd/data
 * @see https://twilio-ui-admin-qa.cc-nonprod.asurion53.com/csd
 */
export async function getChannelShareData(callId: string, client: Partner): Promise<ChannelShareData | null> {
    const {
        features: { csdEnabled },
    } = getAppConfigSingleton().getPartnersConfig(client);

    if (!csdEnabled) return null;

    try {
        const data = await getSharedApiClient()
            .post("api/v1/csd/data", { prefixUrl: env.ivrApisBaseUrl, json: { channel, client, callId } })
            .json<{ RESPONSE: { DATA: { id: string; value: string }[] } }>();
        const result = Object.fromEntries(data.RESPONSE.DATA.map(({ id, value }) => [id, value]));
        return {
            ...result,
            mdn: result?.MDN && result.COUNTRY_CODE && `+${result.COUNTRY_CODE}${result.MDN}`,
            callerId: result?.ANI && result.COUNTRY_CODE && `+${result.COUNTRY_CODE}${result.ANI}`,
        };
    } catch (err: unknown) {
        const status = err instanceof HTTPError && err.response.status;
        logger.error({ err, status }, "Channel Share Database API call failed");
        return null;
    }
}
